/**
 * Vendor Services
 * Services for vendor management operations
 */
// Export all service classes
export { VendorService } from './VendorService';
export { VendorTypeService } from './VendorTypeService';
export { VendorStatusService } from './VendorStatusService';
export { VendorContactService } from './VendorContactService';
export { VendorLocationService } from './VendorLocationService';
export { VendorDocumentService } from './VendorDocumentService';
export { VendorDocumentTypeService } from './VendorDocumentTypeService';
export { VendorTermService } from './VendorTermService';
export { VendorTermPeriodService } from './VendorTermPeriodService';
export { VendorPaymentService } from './VendorPaymentService';
export { VendorDonationService } from './VendorDonationService';
export { VendorStatusHistoryService } from './VendorStatusHistoryService';
export { VendorLogService } from './VendorLogService';
export { UserVendorService } from './UserVendorService';
export { VendorRegistrationService } from './VendorRegistrationService';
export { VendorSocialMediaService } from './VendorSocialMediaService';
export { VendorShopService } from './VendorShopService';
export { VendorLedgerService } from './VendorLedgerService';
export { VendorPayoutService } from './VendorPayoutService';
// Import for factory function
import { VendorService } from './VendorService';
import { VendorTypeService } from './VendorTypeService';
import { VendorStatusService } from './VendorStatusService';
import { VendorContactService } from './VendorContactService';
import { VendorLocationService } from './VendorLocationService';
import { VendorDocumentService } from './VendorDocumentService';
import { VendorDocumentTypeService } from './VendorDocumentTypeService';
import { VendorTermService } from './VendorTermService';
import { VendorTermPeriodService } from './VendorTermPeriodService';
import { VendorPaymentService } from './VendorPaymentService';
import { VendorDonationService } from './VendorDonationService';
import { VendorStatusHistoryService } from './VendorStatusHistoryService';
import { VendorLogService } from './VendorLogService';
import { UserVendorService } from './UserVendorService';
import { VendorRegistrationService } from './VendorRegistrationService';
import { VendorSocialMediaService } from './VendorSocialMediaService';
import { VendorShopService } from './VendorShopService';
import { VendorLedgerService } from './VendorLedgerService';
import { VendorPayoutService } from './VendorPayoutService';
/**
 * Create all vendor services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all vendor services
 */
export function createVendorServices(http, config) {
    return {
        vendor: new VendorService(http, config),
        vendorType: new VendorTypeService(http, config),
        vendorStatus: new VendorStatusService(http, config),
        vendorContact: new VendorContactService(http, config),
        vendorLocation: new VendorLocationService(http, config),
        vendorDocument: new VendorDocumentService(http, config),
        vendorDocumentType: new VendorDocumentTypeService(http, config),
        vendorTerm: new VendorTermService(http, config),
        vendorTermPeriod: new VendorTermPeriodService(http, config),
        vendorPayment: new VendorPaymentService(http, config),
        vendorDonation: new VendorDonationService(http, config),
        vendorStatusHistory: new VendorStatusHistoryService(http, config),
        vendorLog: new VendorLogService(http, config),
        userVendor: new UserVendorService(http, config),
        vendorRegistration: new VendorRegistrationService(http, config),
        vendorSocialMedia: new VendorSocialMediaService(http, config),
        vendorShop: new VendorShopService(http, config),
        vendorLedger: new VendorLedgerService(http, config),
        vendorPayout: new VendorPayoutService(http, config),
    };
}
//# sourceMappingURL=index.js.map